import service from '../utils/request_api'

export function withdraw_balance(params){
    return service({
        url:'/withdraw_balance',
        method:'get',
        params
    })
 }


 export function get_withdraw_sign(params){
    return service({
        url:'/get_withdraw_sign',
        method:'get',
        params
    })
 }


export function remove_balance(params){
    return service({
        url:'/remove_balance',
        method:'get',
        params
    })
}
